export default "__VITE_ASSET__BFXtUJ9v__"